export default __webpack_public_path__ + "static/example-mandrake-ba25183e21c2280b34c3e6d20acddd46.svg";